"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SearchBox_1 = require("./SearchBox");
Object.defineProperty(exports, "SearchBox", { enumerable: true, get: function () { return SearchBox_1.SearchBox; } });
//# sourceMappingURL=index.js.map